import api from 'api';

export const loadApplications = api(
  'GET /api/conversion-pages/filters/applications'
);

export const loadDomains = api('GET /api/conversion-pages/filters/domains');

export const loadLocales = api('GET /api/conversion-pages/filters/locales');

export const loadFlows = api('GET /api/conversion-pages/filters/flows');

export const loadNetworks = api('GET /api/conversion-pages/filters/networks');

export const loadPlatforms = api('GET /api/conversion-pages/filters/platforms');

export const loadTags = api('GET /api/conversion-pages/filters/tags');

export const loadUsedInAds = api(
  'GET /api/conversion-pages/filters/used-in-ads'
);

export const loadIsNew = api('GET /api/conversion-pages/filters/is-new');
